export default __webpack_public_path__ + "static/media/csr-ca.291a6862.png";